import * as React from 'react'
import MeQuery from './queries/MeQuery'
import { UserRole } from '../graphql/queries/me'

interface IsAdminProps {
  children: (isAdmin: boolean) => React.ReactNode
}

const IsAdmin: React.SFC<IsAdminProps> = ({
  children
}) => {
  return (
  <MeQuery>
    {({ data, loading, error }) => {
      if (loading) {
        return children(false)
      }

      if (data == null) {
        return children(false)
      }

      return children(data.user.roles.indexOf(UserRole.ADMIN) !== -1)
    }}
  </MeQuery>)
}

export default IsAdmin



// WEBPACK FOOTER //
// ./src/components/IsAdmin.tsx